import { trackAnalyticsEvent } from '@cof/refi-web-sdk';
import { environment } from '../../../environment/environment.js';

const ENV_PATH = environment.isStaticCloud() ? '/_origin/dxgw/_call' : '';

export const REFI_PERSONAL_CONST = {
  SAVE_CUSTOMER_CONTACT_URL: `${ENV_PATH}/protected/957522/fs-personal-bff/save-customer-contact`,
  SAVE_PERSONAL_INFO_URL: `${ENV_PATH}/protected/957522/fs-personal-bff/lead/save-personal-info`,
  VALIDATE_CUSTOMER_DETAILS_URL: `${ENV_PATH}/protected/957522/fs-personal-bff/validate-customer-details`,
  GET_APPLICANTS_INFORMATION_URL: (eAppId) =>
    `${ENV_PATH}/protected/957522/fs-personal-bff/applications/${eAppId}/applicants/~`,
  GET_APPLICATION_TASKS_URL: (eAppId) =>
    `${ENV_PATH}/protected/957522/fs-personal-bff/applications/${eAppId}/application-tasks`,
  PATCH_APPLICANTS_INFORMATION_URL: (eAppId, applicantId) =>
    `${ENV_PATH}/protected/957522/fs-personal-bff/applications/${eAppId}/applicants/${applicantId}`,
  GET_FEATURE_TOGGLE_URL: (featureKey) =>
    `${ENV_PATH}/protected/957522/fs-personal-bff/features/${featureKey}`,
  HTTP_HEADERS: {
    Accept: 'application/json;v=1',
    'Content-Type': 'application/json;v=1',
  },
  REFI_SESSION_KEY: 'auto-refi-session',
  FIRST_NAME_SESSION_KEY: 'first-name',
  REFI_PI_KEY: 'auto-refi-pi',
  REFI_CI_KEY: 'refi-ci',
  MARKETING_ATTRIBUTE_COOKIE: 'afw3',
  STIP_TYPE: {
    PROOF_OF_RESIDENCE: 'ProofOfResidence',
    PROOF_OF_INCOME: 'ProofOfIncome',
  },
  STIP_INCOMPLETE: 'INCOMPLETE',
  FEATURE_TOGGLES: {
    ICONIC_PQ_FEATURE_TOGGLE: 'iconic-invisible-pq',
  },
  hostAppEventActionName: {
    initiateAnimationCompletion: 'initiate-animation-completion',
    initiateAnimationTransition: 'initiate-animation-transition',
  },
  TIMEOUT_IN_MS: 10000,
  isLocalEnv() {
    return window.location.hostname === 'localhost';
  },
  isSBEnv() {
    return (
      window.location.hostname === 'auto-refi-sb.clouddqt.capitalone.com' ||
      window.location.hostname === 'coaf-refi-web-ui-sb.capitalone.com' ||
      window.location.hostname ===
        'fs-personal-mfe-sb.clouddqtext.capitalone.com'
    );
  },
  isDevEnv() {
    return (
      window.location.hostname === 'auto-refi-dev.clouddqt.capitalone.com' ||
      window.location.hostname === 'coaf-refi-web-ui-dev.capitalone.com' ||
      window.location.hostname ===
        'fs-personal-mfe-dev.clouddqtext.capitalone.com'
    );
  },
  isQAEnv() {
    return (
      window.location.hostname === 'autorefi-ext-preprod.capitalone.com' ||
      window.location.hostname === 'auto-refi-qa.clouddqt.capitalone.com' ||
      window.location.hostname === 'coaf-refi-web-ui-qa.capitalone.com' ||
      window.location.hostname === 'fs-personal-mfe-qa.capitalone.com'
    );
  },
  isProdEnv() {
    return (
      window.location.hostname === 'autorefi.capitalone.com' ||
      window.location.hostname === 'coaf-refi-web-ui.capitalone.com' ||
      window.location.hostname === 'fs-personal-mfe.capitalone.com'
    );
  },
  TRACK_EVENT: trackAnalyticsEvent,
  REFI_WEB_UI_URL: () => {
    switch (window.location.hostname) {
      case 'autorefi.capitalone.com':
        return 'https://coaf-refi-web-ui.capitalone.com';
      case 'autorefi-ext-preprod.capitalone.com':
      case 'auto-refi-qa.clouddqt.capitalone.com':
      case 'auto-refi-dev.clouddqt.capitalone.com':
      case 'auto-refi-sb.clouddqt.capitalone.com':
        return 'https://coaf-refi-web-ui-qa.capitalone.com';
      default:
        return 'http://localhost:4300';
    }
  },
  PREQUAL_BFF_HIGHLINE_PRODUCT_ID() {
    return this.isProdEnv() ? 'refi-prequalify-bff' : 'refi-prequalify-bff-np';
  },
  HIGHLINE_URL_PREFIX: () => `${ENV_PATH}`,
  US_STATES: [
    { value: 'AL', name: 'Alabama' },
    { value: 'AK', name: 'Alaska' },
    { value: 'AR', name: 'Arkansas' },
    { value: 'AZ', name: 'Arizona' },
    { value: 'AE', name: 'Armed Forces' },
    { value: 'AA', name: 'Armed Forces Americas' },
    { value: 'AP', name: 'Armed Forces Pacific' },
    { value: 'CA', name: 'California' },
    { value: 'CO', name: 'Colorado' },
    { value: 'CT', name: 'Connecticut' },
    { value: 'DE', name: 'Delaware' },
    { value: 'DC', name: 'District Of Columbia' },
    { value: 'FL', name: 'Florida' },
    { value: 'GA', name: 'Georgia' },
    { value: 'HI', name: 'Hawaii' },
    { value: 'ID', name: 'Idaho' },
    { value: 'IL', name: 'Illinois' },
    { value: 'IN', name: 'Indiana' },
    { value: 'IA', name: 'Iowa' },
    { value: 'KS', name: 'Kansas' },
    { value: 'KY', name: 'Kentucky' },
    { value: 'LA', name: 'Louisiana' },
    { value: 'ME', name: 'Maine' },
    { value: 'MD', name: 'Maryland' },
    { value: 'MA', name: 'Massachusetts' },
    { value: 'MI', name: 'Michigan' },
    { value: 'MN', name: 'Minnesota' },
    { value: 'MS', name: 'Mississippi' },
    { value: 'MO', name: 'Missouri' },
    { value: 'MT', name: 'Montana' },
    { value: 'NE', name: 'Nebraska' },
    { value: 'NV', name: 'Nevada' },
    { value: 'NH', name: 'New Hampshire' },
    { value: 'NJ', name: 'New Jersey' },
    { value: 'NM', name: 'New Mexico' },
    { value: 'NY', name: 'New York' },
    { value: 'NC', name: 'North Carolina' },
    { value: 'ND', name: 'North Dakota' },
    { value: 'OH', name: 'Ohio' },
    { value: 'OK', name: 'Oklahoma' },
    { value: 'OR', name: 'Oregon' },
    { value: 'PA', name: 'Pennsylvania' },
    { value: 'RI', name: 'Rhode Island' },
    { value: 'SC', name: 'South Carolina' },
    { value: 'SD', name: 'South Dakota' },
    { value: 'TN', name: 'Tennessee' },
    { value: 'TX', name: 'Texas' },
    { value: 'UT', name: 'Utah' },
    { value: 'VT', name: 'Vermont' },
    { value: 'VA', name: 'Virginia' },
    { value: 'WA', name: 'Washington' },
    { value: 'WV', name: 'West Virginia' },
    { value: 'WI', name: 'Wisconsin' },
    { value: 'WY', name: 'Wyoming' },
  ],
  INELIGIBLE_REFI_STATES: ['HI', 'AK', ''],
  ACTIVE_INCOME_VERIFICATION_TYPE: {
    yes: 'Yes',
    no: 'No',
  },
  APPLICANT_TYPE: {
    PRIMARY_APPLICANT: 'primaryApplicant',
    CO_APPLICANT: 'coApplicant',
  },
  EMPLOYMENT_STATUS: {
    SELF_EMPLOYED: 'selfemployed',
    EMPLOYED: 'employed',
    OTHER: 'other',
    UNEMPLOYED: 'unemployed',
    RETIRED: 'retired',
  },
  FINANCIAL: 'financial',
  NON_FINANCIAL: 'nonfinancial',
  PHONE_TYPES: ['Mobile', 'Home', 'Work'],
  PHONE_TYPE_MAP: {
    MOBILE: 'Mobile',
    HOME: 'Home',
    WORK: 'Work',
  },
  PROGRESS_BAR_MICRO_STEPS: {
    macroStepName: 'Check eligibility',
    microStepsList: [
      'name',
      'communication',
      'identity',
      'address',
      'employment',
      'income',
      'coborrower',
      'co-app-communication',
      'co-app-identity',
      'co-app-address',
      'co-app-employment',
      'co-app-income',
      'termsAndConditions',
      'vehicleLoan',
      'vehicle',
      'loan',
      'review',
    ],
  },
  UFO_PROGRESS_BAR_MICRO_STEPS: {
    macroStepName: 'Check eligibility',
    microStepsList: [
      'termsAndConditions',
      'vehicleLoan',
      'vehicle',
      'loan',
      'upfront-offers',
      'name',
      'communication',
      'identity',
      'address',
      'employment',
      'income',
      'coborrower',
      'co-app-communication',
      'co-app-identity',
      'co-app-address',
      'co-app-employment',
      'co-app-income',
      'review',
    ],
  },
  LIGHTHOUSE_QUERY_PARAM: {
    NAME: {
      paramValue: 'lighthouse-name',
      stepIndex: 0,
    },
    COMMUNICATION: {
      paramValue: 'lighthouse-communication',
      stepIndex: 1,
    },
    IDENTITY: { paramValue: 'lighthouse-identity', stepIndex: 2 },
    ADDRESS: { paramValue: 'lighthouse-address', stepIndex: 3 },
    EMPLOYMENT: { paramValue: 'lighthouse-employment', stepIndex: 4 },
    INCOME: { paramValue: 'lighthouse-income', stepIndex: 5 },
    COBORROWER: { paramValue: 'lighthouse-coborrower', stepIndex: 4 },
    COAPP_COMMUNICATION: {
      paramValue: 'lighthouse-co-app-communication',
      stepIndex: 6,
    },
    COAPP_IDENTITY: { paramValue: 'lighthouse-co-app-identity', stepIndex: 7 },
    COAPP_ADDRESS: { paramValue: 'lighthouse-co-app-address', stepIndex: 8 },
    COAPP_EMPLOYMENT: {
      paramValue: 'lighthouse-co-app-employment',
      stepIndex: 9,
    },
    COAPP_INCOME: { paramValue: 'lighthouse-co-app-income', stepIndex: 10 },
  },
  NDI_EXPERIMENT: 'NDI',
  NDI_TEST: 'ndi_test',
  ICONIC_V2: 'iconic-prequal-v2-only',
  APPLICATION_TYPE: {
    JOINT: 'JOINT',
    SINGLE: 'SINGLE',
  },
  PRONOUN: {
    I: 'I',
    WE: 'We',
  },
  POSSESSIVE_PRONOUN: {
    MY: 'my',
    OUR: 'our',
  },
  CONSENT_MODAL_PERSON_TEXT: {
    SINGLE: 'I',
    CO_APP: 'My co-borrower and I',
  },
};

export const EDIT_CARD_CONST = {
  STRATUM_REFS: {
    'personal-card': {
      CARD_NAME: 'personal',
    },
    'address-card': {
      CARD_NAME: 'address',
    },
    'income-card': {
      CARD_NAME: 'income',
    },
  },
  STRATUM_CARD_TAG_TYPE: {
    UNSAVED_EDIT_ERROR: 'unsaved-edit-error',
  },
};
